import { render, staticRenderFns } from "./QuoteItem.vue?vue&type=template&id=1595f482&scoped=true"
import script from "./QuoteItem.vue?vue&type=script&lang=js"
export * from "./QuoteItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1595f482",
  null
  
)

export default component.exports